/**
 * getCurrentUrl
 *
 * Current URL without querystring
 */
export function getCurrentUrl() {
  try {
    return `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
  } catch (err) {
    console.error("Unable to resolve current Url", err);
    return "";
  }
}
